module.exports = __webpack_public_path__ + "img/elite.2027f712.svg";